export default __webpack_public_path__ + "static/media/tarjeta-grafica-tooltip.c2a1c6fc.png";